<menu ng-click="onMenuClick()" class="new-menu" ng-class="menuClass">
    <i class="fa fa-small fa-plus circled"></i>
    <section class="title">{{"new" | translate | uppercase}}</section>
    <nav id="new-menu" c-toggle="menuVisible"  c-toggle-type="fade">
        <ul>
            <li><a ng-click="onCaseflowClick()">{{"caseflow" | translate | uppercase}}</a></li>
            <li><a ng-click="onDocflowClick()">{{"docflow" | translate | uppercase}}</a></li>
            <li><a ng-click="onContractflowClick()">{{"contractflow" | translate | uppercase}}</a></li>
        </ul>
    </nav>
</menu>
